import { buffer, concatAll } from "rxjs/operators";
export function hold(releaseNotifier) {
    return (source) => source.pipe(buffer(releaseNotifier), concatAll());
}
//# sourceMappingURL=hold.js.map